// Single-line path rendering: when the crumbs don't fit, whole leading crumbs are
// dropped behind an ellipsis prefix ("… <sep>"). The last crumb is always kept.
// Returns the index of the first visible crumb (0 = everything fits).
export const getVisibleStartIndex = (
  widths: number[],
  separatorWidth: number,
  ellipsisWidth: number,
  available: number
): number => {
  if (!widths.length) return 0;
  const fullWidth =
    widths.reduce((sum, width) => sum + width, 0) +
    separatorWidth * Math.max(widths.length - 1, 0);
  if (fullWidth <= available) return 0;

  // The ellipsis prefix is followed by its own separator.
  const prefixWidth = ellipsisWidth + separatorWidth;
  let usedWidth = widths[widths.length - 1];
  let startIndex = widths.length - 1;
  for (let i = widths.length - 2; i >= 0; i--) {
    const nextWidth = usedWidth + separatorWidth + widths[i];
    if (nextWidth + prefixWidth > available) break;
    usedWidth = nextWidth;
    startIndex = i;
  }
  return startIndex;
};
